import { Component, type ErrorInfo, type ReactNode } from 'react'
import { reportClientError } from '../api/clientErrors'

type ErrorBoundaryProps = {
  children: ReactNode
}

type ErrorBoundaryState = {
  message: string | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { message: null }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { message: error.message || 'Неизвестная ошибка' }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Market app render error', error, info)
    reportClientError({
      message: error.message || 'Unknown render error',
      stack: error.stack,
      component_stack: info.componentStack ?? undefined,
      source: 'market',
    })
  }

  render() {
    if (this.state.message) {
      return (
        <main className="market-login">
          <div className="market-panel">
            <h1>Ошибка приложения</h1>
            <p className="market-muted">{this.state.message}</p>
          </div>
        </main>
      )
    }

    return this.props.children
  }
}
